export default "__VITE_ASSET__611e499c__"